<template>
    <div class="share-btn profile-heading__icon">

        <!-- If on mobile with web share API, show direct share button -->
        <navigator-share v-if="isItMobile && webShareApiSupported" :url="currentPath"
            :title="'Kiel.KulturKompass - echt Kult, echt Kiel!'" v-bind:on-error="onShareError"
            v-bind:on-success="onShareSuccess">
            <template v-slot:clickable>
                <button class="btn btn-round teilen-knopf" aria-label="Inhalt teilen">
                    <i class="material-icons" aria-hidden="true">share</i>
                </button>
            </template>
        </navigator-share>

        <!-- If not on mobile or web share API not supported, show overlay button -->
        <template v-else>
            <button @click.stop.prevent="toggleShareOptions" class="btn btn-round teilen-knopf"
                :aria-expanded="showShareOptions" aria-label="Inhalt teilen" aria-haspopup="dialog">
                <i class="material-icons" aria-hidden="true">share</i>
            </button>

            <!-- Overlay backdrop -->
            <div v-if="showShareOptions" class="share-overlay-backdrop" @click.stop.prevent="toggleShareOptions"
                role="presentation"></div>

            <!-- Share options dialog -->
            <div v-if="showShareOptions" class="share-options-dialog" role="dialog" aria-labelledby="share-dialog-title"
                aria-modal="true" @click.stop.prevent>
                <h2 id="share-dialog-title" class="visually-hidden">Teilen-Optionen</h2>

                <button class="close-button" @click.stop.prevent="toggleShareOptions"
                    aria-label="Teilen-Dialog schließen">
                    <i class="material-icons">close</i>
                </button>

                <div class="share-options-list">
                    <button @click.stop.prevent="copyLink" class="share-option" aria-label="Link kopieren">
                        <i class="material-icons icon">link</i>
                        Link kopieren
                    </button>

                    <button @click.stop.prevent="shareViaEmail" class="share-option" aria-label="Per E-Mail teilen">
                        <i class="material-icons icon">email</i>
                        E-Mail
                    </button>

                    <button @click.stop.prevent="shareOnFacebook" class="share-option" aria-label="Auf Facebook teilen">
                        <svg class="icon" viewBox="0 0 24 24" fill="currentColor">
                            <path
                                d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                        </svg>
                        Facebook
                    </button>

                    <button @click.stop.prevent="shareOnWhatsApp" class="share-option" aria-label="Auf WhatsApp teilen">
                        <svg class="icon" viewBox="0 0 24 24" fill="currentColor">
                            <path
                                d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488" />
                        </svg>
                        WhatsApp
                    </button>

                    <button @click.stop.prevent="shareOnTelegram" class="share-option" aria-label="Auf Telegram teilen">
                        <svg class="icon" viewBox="0 0 24 24" fill="currentColor">
                            <path
                                d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
                        </svg>
                        Telegram
                    </button>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
import NavigatorShare from 'vue-navigator-share';
import { isMobile } from 'mobile-device-detect';

export default {
    name: "ShareButton",
    components: {
        NavigatorShare
    },
    data() {
        return {
            isItMobile: isMobile ? true : false,
            showShareOptions: false,
            lastFocusedElement: null
        }
    },
    computed: {
        currentPath() {
            return window.location.href;
        },
        webShareApiSupported() {
            return navigator && navigator.share;
        }
    },
    methods: {
        onShareError(err) {
            alert(err);
            console.log(err);
        },
        onShareSuccess(err) {
            console.log(err);
        },
        toggleShareOptions(event) {
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }

            if (!this.showShareOptions) {
                // Store the last focused element before opening the dialog
                this.lastFocusedElement = document.activeElement;
                // Prevent background scrolling
                document.body.style.overflow = 'hidden';
            } else {
                // Restore background scrolling
                document.body.style.overflow = '';
                // Restore focus to the last focused element
                if (this.lastFocusedElement) {
                    this.lastFocusedElement.focus();
                }
            }

            this.showShareOptions = !this.showShareOptions;

            if (this.showShareOptions) {
                // Focus the first share option when dialog opens
                this.$nextTick(() => {
                    const firstButton = this.$el.querySelector('.share-option');
                    if (firstButton) firstButton.focus();
                });
            }
        },
        handleKeydown(event) {
            if (event.key === 'Escape' && this.showShareOptions) {
                this.toggleShareOptions();
            } else if (event.key === 'Tab' && this.showShareOptions) {
                // Get all focusable elements in the dialog
                const focusableElements = this.$el.querySelectorAll(
                    '.share-option, .close-button'
                );
                const firstFocusable = focusableElements[0];
                const lastFocusable = focusableElements[focusableElements.length - 1];

                if (event.shiftKey) {
                    // If shift + tab and on first element, move to last element
                    if (document.activeElement === firstFocusable) {
                        event.preventDefault();
                        lastFocusable.focus();
                    }
                } else {
                    // If tab and on last element, move to first element
                    if (document.activeElement === lastFocusable) {
                        event.preventDefault();
                        firstFocusable.focus();
                    }
                }
            }
        },
        shareOnFacebook() {
            const url = encodeURIComponent(this.currentPath);
            window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, '_blank');
            this.toggleShareOptions();
        },
        shareViaEmail() {
            const subject = encodeURIComponent(document.title || 'Shared Content');
            const body = encodeURIComponent(`Schau dir das an: ${document.title || 'Shared Content'}\n\n${this.currentPath}`);
            window.location.href = `mailto:?subject=${subject}&body=${body}`;
            this.toggleShareOptions();
        },
        shareOnWhatsApp() {
            const text = encodeURIComponent(`${document.title || 'Shared Content'}\n${this.currentPath}`);
            const url = `https://wa.me/?text=${text}`;
            window.open(url, '_blank');
            this.toggleShareOptions();
        },
        shareOnTelegram() {
            const url = encodeURIComponent(this.currentPath);
            const text = encodeURIComponent(document.title || 'Shared Content');
            window.open(`https://t.me/share/url?url=${url}&text=${text}`, '_blank');
            this.toggleShareOptions();
        },
        copyLink() {
            navigator.clipboard.writeText(this.currentPath)
                .then(() => {
                    // Use the application's notification system if available, otherwise fallback to alert
                    if (this.$notify) {
                        this.$notify({
                            duration: 2500,
                            title: 'Link kopiert',
                            text: 'Link wurde in die Zwischenablage kopiert!'
                        });
                    } else {
                        alert('Link in die Zwischenablage kopiert!');
                    }
                })
                .catch(err => {
                    console.error('Link konnte nicht kopiert werden: ', err);
                    alert('Link konnte nicht kopiert werden. Bitte versuchen Sie es manuell.');
                });
            this.toggleShareOptions();
        }
    },
    mounted() {
        document.addEventListener('keydown', this.handleKeydown);
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleKeydown);
        // Ensure we restore scrolling when component is destroyed
        document.body.style.overflow = '';
    }
}
</script>

<style lang="scss">
@import '@/scss/_variables.scss';

.share-btn {
    position: relative;

    .teilen-knopf {
        color: #00183E !important;
        background-color: #FFF !important;
        border: 2px solid #00183E;
    }

    .teilen-knopf:hover,
    .teilen-knopf:active {
        color: #FFF !important;
        background-color: #00183E !important;
        border: 2px solid #00183E !important;
    }

    .teilen-knopf:focus-visible {
        border: 2px dashed #E30059 !important;
        border-radius: 100px !important;
        background-color: #FFF;
    }

    .teilen-knopf:focus-visible:before {
        background: none;
        border: 2px solid #00183E;
        border-radius: 100px;
        content: "";
        display: block;
        position: absolute;
        top: 1px;
        left: 1px;
        right: 1px;
        bottom: 1px;
        pointer-events: none;
    }
}

.share-overlay-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1001;
    cursor: not-allowed;
}

.share-options-dialog {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: white;
    border-radius: 8px;
    padding: 20px;
    min-width: 280px;
    max-width: 90%;
    z-index: 1002;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    outline: none;

    .close-button {
        position: absolute;
        top: 10px;
        right: 10px;
        background: none;
        border: none;
        cursor: pointer;
        padding: 5px;
        color: #666;
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;

        &:hover {
            color: #333;
        }

        .material-icons {
            font-size: 20px;
            width: 20px;
            height: 20px;
            color: #666;
        }
    }

    .share-options-list {
        display: flex;
        flex-direction: column;
        gap: 10px;
        margin-top: 20px;
    }

    .share-option {
        display: flex;
        align-items: center;
        padding: 12px 16px;
        border: none;
        background: none;
        cursor: pointer;
        border-radius: 4px;
        transition: all 0.2s;
        color: #333;
        font-size: 16px;
        line-height: 1.5;
        width: 100%;

        &:hover {
            background-color: #f5f5f5;

            .icon {
                color: $primary;
            }

            svg.icon {
                fill: $primary;
            }
        }

        &:focus {
            outline: 2px solid $primary;
            outline-offset: 2px;
        }

        .icon {
            width: 24px;
            height: 24px;
            margin-right: 12px;
            flex-shrink: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: color 0.2s;
            font-size: 24px;
            color: #333;

            &.material-icons {
                font-size: 24px;
            }

            &.svg-icon {
                width: 24px;
                height: 24px;
                fill: currentColor;
            }
        }
    }
}

.visually-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
}

body[dir="rtl"] {
    .share-option .icon {
        margin-right: 0;
        margin-left: 12px;
    }
}
</style>
